import axios from 'axios'

export default {
  /**
   * Gets and sets all owned placesõ
   */
  getOwnedPlaces: async ({ commit, rootState }) => {
    commit(
      'app/setLoading',
      { type: 'getOwnedPlaces', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/owner/adminplaces`, config)
        .then(response => {
          commit('setOwnedPlaces', response.data)
          commit(
            'app/setLoading',
            { type: 'getOwnedPlaces', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getOwnedPlaces', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets places
   */
  getPlaces: async ({ commit, rootState }) => {
    commit('app/setLoading', { type: 'getPlaces', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/places`, config)
        .then(response => {
          let totalSpots = 0
          let availableSpots = 0
          const localPlaces = []
          response.data.forEach(place => {
            localPlaces.push(place)
            if (
              Array.isArray(place.ChildPLaces) &&
              place.ChildPlaces.length > 0
            ) {
              place.ChildPlaces.forEach(child => {
                localPlaces.push(child)
              })
            }
            if (place.Id !== 1 && place.Operator === 'B') {
              totalSpots += place.TotalSpots
              availableSpots += place.AvailableSpots
            }
          })
          commit('setPlaces', [])
          commit('setTotalSpots', totalSpots)
          commit('setAvailableSpots', availableSpots)
          commit(
            'app/setLoading',
            { type: 'getPlaces', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getPlaces', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets place by place id
   * @param {Number} - place id
   */
  getPlace: async ({ commit, rootState }, id) => {
    commit('app/setLoading', { type: 'getPlace', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/places/${id}`, config)
        .then(response => {
          commit('setPlace', response.data)
          commit(
            'app/setLoading',
            { type: 'getPlace', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getPlace', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Post place
   */
  postPlace({ commit, rootState }) {
    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postPlace', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/places`,
          {
            ...rootState.places.place
          },
          config
        )
        .then(response => {
          commit(
            'app/setLoading',
            { type: 'postPlace', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Changes saved'
            },
            { root: true }
          )
          resolve(response.data)
        })
        .catch(error => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'error',
              message: error.response.data
                ? error.response.data.Error
                : 'Something went wrong! Please try again later.'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postPlace', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
          reject(error)
        })
    })
  },
  /**
   * Returns controllers by place id
   * @param {Number} - place id
   */
  async getGateControllers({ commit, rootState }, id) {
    commit(
      'app/setLoading',
      { type: 'getGateControllers', state: true },
      { root: true }
    )
    commit('setLoadingControllers', true)
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .get(
        `${process.env.VUE_APP_URL}/adminapi/places/${id}/gatecontrollers`,
        config
      )
      .then(response => {
        commit('setControllers', response.data)
        commit(
          'app/setLoading',
          { type: 'getGateControllers', state: false },
          { root: true }
        )
        commit('setLoadingControllers', false)
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'getGateControllers', state: false },
          { root: true }
        )
        commit('setLoadingControllers', false)
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Returns controllers by place id
   * @param {Number} - place id
   */
  async getControllerFirmwareList({ commit, rootState }, id) {
    commit(
      'app/setLoading',
      { type: 'getGateControllerFirmwareList', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .get(
        `${process.env.VUE_APP_URL}/adminapi/places/${id}/gatecontrollers/firmware-list`,
        config
      )
      .then(response => {
        commit('setControllerFirmwareList', response.data)
        commit(
          'app/setLoading',
          { type: 'getGateControllerFirmwareList', state: false },
          { root: true }
        )
        commit('setLoadingControllers', false)
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'getGateControllerFirmwareList', state: false },
          { root: true }
        )
        commit('setLoadingControllers', false)
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Returns controllers logs by controller id
   * @param {Object} - controllerId, placeId
   */
  getControllerLogs({ commit, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'getControllerLogs', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    axios
      .get(
        `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/gatecontrollers/${payload.controllerId}/logs`,
        config
      )
      .then(response => {
        commit('setControllerLogs', response.data)
        commit(
          'app/setLoading',
          { type: 'getControllerLogs', state: false },
          { root: true }
        )
        commit('app/setError', null, { root: true })
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'getControllerLogs', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Send gate controller command
   * @param {Number} - place id
   */
  async sendGateControllerCommand({ commit, rootState }, payload) {
    commit(
      'app/setLoading',
      { type: 'sendGateControllerCommand', state: true },
      { root: true }
    )
    if (payload.command === 'STATUS') {
      commit('setRefreshingControllers', true)
    }
    if (
      payload.command === 'KEEP_OPEN' ||
      payload.command === 'RELEASE_KEEP_OPEN'
    ) {
      commit('setOpeningOrClosingGate', true)
    }
    commit('app/setError', null, { root: true })
    const config = {
      headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
    }
    await axios
      .post(
        `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/gatecontrollers/${payload.controllerId}`,
        {
          Command: payload.command,
          GateId: payload.gateId || null,
          GateControllerId: payload.controllerId || null,
          ForGate: payload.forGate || false,
          SendMode: payload.sendMode,
          OutputList: payload.outputList || [],
          FirmwareUrl: payload.firmwareUrl || ''
        },
        config
      )
      .then(() => {
        if (payload.command === 'STATUS') {
          axios
            .get(
              `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/gatecontrollers`,
              config
            )
            .then(response => {
              commit('setControllers', response.data)
              commit('setRefreshingControllers', false)
              commit('setSelectedController', undefined)
            })
        }
        // if (
        //   payload.command === 'KEEP_OPEN' ||
        //   payload.command === 'RELEASE_KEEP_OPEN'
        // ) {
        //   commit('setGateIsAlwaysOpened', {
        //     controllerId: payload.controllerId,
        //     gateIndex: payload.gateIndex,
        //     isAlwaysOpened: false
        //   })
        // }
        if (
          payload.command === 'KEEP_OPEN' ||
          payload.command === 'RELEASE_KEEP_OPEN'
        ) {
          commit('setGateIsAlwaysOpened', {
            controllerId: payload.controllerId,
            gateIndex: payload.gateIndex,
            isAlwaysOpened: true
          })

          if (payload.command === 'RELEASE_KEEP_OPEN') {
            commit('setGateIsAlwaysOpened', {
              controllerId: payload.controllerId,
              gateIndex: payload.gateIndex,
              isAlwaysOpened: false
            })
          }
          commit('setOpeningOrClosingGate', false)
        }
        commit(
          'app/setLoading',
          { type: 'sendGateControllerCommand', state: false },
          { root: true }
        )
        commit('app/setError', null, { root: true })
        commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Command sent successfully!'
          },
          { root: true }
        )
      })
      .catch(error => {
        commit(
          'app/setLoading',
          { type: 'sendGateControllerCommand', state: false },
          { root: true }
        )
        commit('setRefreshingControllers', false)
        commit('setSelectedController', undefined)
        commit('setGateIsAlwaysOpened', {
          controllerId: payload.controllerId,
          gateIndex: payload.gateIndex,
          isAlwaysOpened: false
        })
        commit('app/setError', error, { root: true })
      })
  },
  /**
   * Post gate controller
   * @param {Object} - gate controller object
   */
  postGateController({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postGateController', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .post(
            `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/gatecontrollers`,
            {
              PlaceId: payload.placeId,
              ...payload.controller
            },
            config
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'postGateController', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'postGateController', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Delete gate controller
   * @param {Object} - gate controller object
   */
  deleteGateController: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'postGateController', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .delete(
          `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/gatecontrollers/${payload.controllerId}`,
          {
            headers: config.headers
          }
        )
        .then(() => {
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Controller removed successfully!'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postGateController', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postGateController', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Returns monthly passes by place id
   * @param {Number} - place id
   */
  getMonthlyPasses({ commit, rootState }, id) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getMonthlyPasses', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/places/${id}/monthlypasses`,
            config
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'getMonthlyPasses', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getMonthlyPasses', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Adds monthly pass under place
   * @param {Number} - place id
   */
  postMonthlyPass({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'postMonthlyPass', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .post(
            `${process.env.VUE_APP_URL}/adminapi/places/${payload.placeId}/monthlypasses`,
            payload.data,
            config
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'postMonthlyPass', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'postMonthlyPass', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  putMonthlyPass({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putMonthlyPass', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/places/${payload.PlaceId}/monthlypasses/${payload.Id}`,
          payload,
          config
        )
        .then(response => {
          resolve(response.data)
          commit(
            'app/setLoading',
            { type: 'putMonthlyPass', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          reject(error)
          commit(
            'app/setLoading',
            { type: 'putMonthlyPass', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
        })
    })
  },
  deleteMonthlyPass({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'putMonthlyPass', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .delete(
            `${process.env.VUE_APP_URL}/adminapi/places/${payload.PlaceId}/monthlypasses/${payload.Id}`,
            { data: { ...payload }, headers: config.headers }
          )
          .then(response => {
            resolve(response.data)
            commit(
              'app/setLoading',
              { type: 'putMonthlyPass', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'putMonthlyPass', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Gets active sessions count for place
   * @param {Number} - place id
   * @returns {Promise<Number>} - Active sessions count
   */
  getActiveSessionsCount: async ({ commit, rootState }, id) => {
    commit(
      'app/setLoading',
      { type: 'getActiveSessionsCount', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })

    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }

      const response = await axios.get(
        `${process.env.VUE_APP_URL}/adminapi/places/${id}/sessions-count`,
        config
      )
      commit(
        'app/setLoading',
        { type: 'getActiveSessionsCount', state: false },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      return {
        sessionsCount: response.data.SessionsCount,
        totalSpots: response.data.TotalSpots,
        availableSpots: response.data.AvailableSpots
      }
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getActiveSessionsCount', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
      throw error // Ensure the error propagates if needed
    }
  }
}
